import { useNavigate } from 'react-router-dom';

const logoUrl =
  'https://storage.readdy-site.link/project_files/fb9a032b-f905-4139-b305-3a12a0952c6a/59b69cfd-0953-4f81-8590-a303a1311dbd_compressed_unnamed.webp';

const internalLinks = [
  { label: '首頁', path: '/' },
  { label: '品牌介紹', path: '/about' },
  { label: '合作通路', path: '/stores' },
  { label: '常見問答', path: '/faq' },
  { label: '閱讀推薦', path: '/blog' },
];

const siteLinks = [
  {
    label: '崧博出版',
    desc: '崧博出版主站',
    url: 'https://sonbook.net/',
  },
  {
    label: '崧博書籍資料庫',
    desc: '完整書目查詢',
    url: 'https://catalog.sonbook.net/',
  },
];

const storeLinks = [
  { label: '博客來', url: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=daiho45' },
  { label: '誠品', url: 'https://www.eslite.com/search?keyword=%E6%A9%9F%E6%9B%9C%E6%96%87%E5%8C%96%E4%BA%8B%E6%A5%AD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8' },
  { label: '金石堂', url: 'https://www.kingstone.com.tw/bookpublish/publist/25015/' },
  { label: '三民', url: 'https://www.sanmin.com.tw/search?pu=%E6%A9%9F%E6%9B%9C' },
  { label: 'momo', url: 'https://www.momoshop.com.tw/search/%E6%A9%9F%E6%9B%9C%E6%96%87%E5%8C%96?brand=%E6%A9%9F%E6%9B%9C%E6%96%87%E5%8C%96' },
  { label: '蝦皮', url: 'https://shopee.tw/sonbook' },
  { label: 'TAAZE 讀冊', url: 'https://www.taaze.tw/rwd_searchResult.html?keyType%5B%5D=3&keyword%5B%5D=%E6%A9%9F%E6%9B%9C%E6%96%87%E5%8C%96' },
  { label: 'Amazon Kindle', url: 'https://www.amazon.com/s?k=%E6%A9%9F%E6%9B%9C%E6%96%87%E5%8C%96' },
  { label: '樂天 Kobo', url: 'https://www.kobo.com/tw/zh' },
  { label: 'Pubu', url: 'https://www.pubu.com.tw/store/4193937' },
];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-100 border-t border-primary-500/10">
      {/* Subtle top glow line */}
      <div className="h-px bg-gradient-to-r from-transparent via-primary-500/30 to-transparent" />

      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        {/* Main footer grid */}
        <div className="py-14 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Column 1: Brand */}
          <div className="md:col-span-5">
            <button
              onClick={() => navigate('/')}
              className="cursor-pointer whitespace-nowrap"
              aria-label="機曜文化 Giyao 首頁"
            >
              <img
                src={logoUrl}
                alt="機曜文化 Giyao"
                className="h-10 w-auto object-contain"
              />
            </button>
            <p className="mt-4 text-sm font-medium text-foreground-200 font-heading tracking-wide">
              機曜文化
            </p>
            <p className="mt-1 text-xs text-primary-400 tracking-wider font-label">
              科普類書籍
            </p>
            <p className="mt-3 text-xs text-foreground-600 font-mono">
              giyao.sonbook.net
            </p>
            <p className="mt-5 text-xs text-foreground-500 leading-[1.9] max-w-[340px]">
              本品牌委託崧博出版經銷，官方網站由崧博出版製作。
            </p>
          </div>

          {/* Column 2: 網站導覽 + 相關網站 */}
          <div className="md:col-span-3">
            <p className="text-[10px] font-medium text-primary-400 tracking-[0.25em] uppercase mb-5 font-label">
              導覽
            </p>
            <ul className="space-y-2.5">
              {internalLinks.map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => navigate(link.path)}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>

            {/* Divider */}
            <div className="mt-6 mb-5 w-8 h-px bg-primary-500/20" />

            <p className="text-[10px] font-medium text-primary-400 tracking-[0.25em] uppercase mb-4 font-label">
              相關網站
            </p>
            <ul className="space-y-2.5">
              {siteLinks.map((link) => (
                <li key={link.url}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="group inline-flex items-center gap-1.5 text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                    <i className="ri-arrow-right-up-line text-[10px] text-foreground-600 group-hover:text-primary-400 transition-colors" />
                  </a>
                  <p className="mt-0.5 text-[11px] text-foreground-600">
                    {link.desc}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: 合作通路 */}
          <div className="md:col-span-4">
            <p className="text-[10px] font-medium text-primary-400 tracking-[0.25em] uppercase mb-5 font-label">
              合作通路
            </p>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {storeLinks.map((link) => (
                <li key={link.url}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap inline-flex items-center gap-1"
                  >
                    {link.label}
                    <i className="ri-arrow-right-up-line text-[9px] text-foreground-700" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-6 border-t border-foreground-900/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 機曜文化事業有限公司
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <a
              href="https://sonbook.net/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              崧博出版
            </a>
            <span className="text-foreground-800">·</span>
            <a
              href="https://catalog.sonbook.net/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              書籍資料庫
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
